import React, { useState } from 'react';
import { TaskData } from '../../../../types/TaskData';
import './SystemPlanningOrder.css';
import SystemPlanningOrderTable from "../systemPlanningOrderTable/SystemPlanningOrderTable";
import SystemPlanningOrderCreation from "../systemPlanningOrderCreation/SystemPlanningOrderCreation";
import {ViewType} from "../../../../types/ViewType";

const SystemPlanningOrder: React.FC = () => {
    const [selectedRow, setSelectedRow] = useState<TaskData | null>(null);
    const [refreshKey, setRefreshKey] = useState(0); // Key to trigger table refresh

    const handleRowSelect = (row: TaskData | null) => {
        setSelectedRow(row);
    };

    const onRefreshTable = () => {
        setSelectedRow(null);
        setRefreshKey(prevKey => prevKey + 1);
    };

    return (
        <div className="measure-order-container">
            <div className="table-container-system">
                <SystemPlanningOrderTable onSelectRow={handleRowSelect}  refreshKey={refreshKey} />
            </div>
            <div className="detail-container-system">
                {selectedRow && (
                    <SystemPlanningOrderCreation key={selectedRow.id} data={selectedRow} onRefreshTable={onRefreshTable} viewType={ViewType.NEW} />
                )}
            </div>
        </div>
    );
};

export default SystemPlanningOrder;
